<template>
  <b-form @keydown.enter.prevent @submit.prevent="submitForm">
    <b-form-group label="Exchange">
      <b-form-radio-group required v-model="formInput.exchange" :options="exchangeOptions"></b-form-radio-group>
    </b-form-group>
    <div v-if="formInput.exchange && exchangeApiKeysWebUrl[formInput.exchange]" class="mb-3">
      <a :href="exchangeApiKeysWebUrl[formInput.exchange]" target="_blank" rel="noopener noreferrer">Create API key</a>
    </div>
    <template v-if="formInput.exchange === 'hyperliquid'">
      <b-form-group label="Label">
        <b-form-input type="text" v-model="formInput.label" minlength="0" maxlength="100"></b-form-input>
      </b-form-group>
      <b-form-group label="Wallet address">
        <b-form-input type="text" class="text-monospace" autocomplete="off" v-model="formInput.apiKey" minlength="1" maxlength="200" required></b-form-input>
      </b-form-group>
      <b-form-group label="Agent private key">
        <b-form-input type="text" class="text-monospace" autocomplete="off" v-model="formInput.secret" minlength="1" maxlength="200" required></b-form-input>
      </b-form-group>
    </template>
    <template v-else>
      <b-form-group label="Whitelist IP address">
        <b-input-group>
          <b-form-input type="text" readonly :value="whitelistIpTextByExchange[formInput.exchange]"></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-secondary" @click="onClickCopyIp" v-b-tooltip.click.blur title="Copied">
              <b-icon-files></b-icon-files>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label="Label">
        <b-form-input type="text" v-model="formInput.label" minlength="0" maxlength="100"></b-form-input>
      </b-form-group>
      <b-form-group label="API key">
        <b-form-input type="text" class="text-monospace" autocomplete="off" v-model="formInput.apiKey" minlength="1" maxlength="200" required></b-form-input>
      </b-form-group>
      <b-form-group label="Secret key">
        <b-form-input type="text" class="text-monospace" autocomplete="off" v-model="formInput.secret" minlength="1" maxlength="200" required></b-form-input>
      </b-form-group>
      <b-form-group label="Passphrase" v-if="shouldShowPasswordInput">
        <b-form-input type="text" class="text-monospace" autocomplete="off" v-model="formInput.password" minlength="1" maxlength="200" required></b-form-input>
      </b-form-group>
    </template>
    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>
    <div class="text-right">
      <b-button type="submit" variant="primary" @click="beforeSubmit" :disabled="isSubmitting">Save</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import _ from "lodash";
  import * as cexAccountService from "@/services/cexAccountService";

  export default {
    name: "AddCexAccountModal",
    inject: ["toastError", "toastSuccess", "toastSuccessDelay", "showLoading", "hideLoading"],
    props: ["modalId"],
    emits: ["done"],

    data() {
      return {
        exchangeOptions: [
          { text: "Binance", value: "binance" },
          { text: "Huobi", value: "huobi" },
          { text: "OKX", value: "okx" },
          { text: "Kucoin", value: "kucoin" },
          { text: "MEXC", value: "mexc" },
          { text: "Gate", value: "gate" },
          { text: "Bybit", value: "bybit" },
          { text: "Bitget", value: "bitget" },
          { text: "Backpack", value: "backpack" },
          { text: "Hyperliquid", value: "hyperliquid" },
        ],
        exchangeApiKeysWebUrl: {
          binance: "https://www.binance.com/my/settings/api-management",
          okx: "https://www.okx.com/account/my-api",
          kucoin: "https://www.kucoin.com/account/api",
          mexc: "https://www.mexc.com/user/openapi",
          gate: "https://www.gate.com/myaccount/profile/api-key/manage",
          bybit: "https://www.bybit.com/app/user/api-management",
          bitget: "https://www.bitget.com/account/newapi",
          backpack: "https://backpack.exchange/portfolio/settings/api-keys",
          hyperliquid: "https://app.hyperliquid.xyz/API",
        },
        whitelistIpTextByExchange: {
          binance: "202.182.119.232",
          huobi: "202.182.119.232",
          okx: "202.182.119.232",
          kucoin: "202.182.119.232",
          mexc: "202.182.119.232",
          gate: "202.182.119.232",
          bybit: "202.182.119.232",
          bitget: "202.182.119.232",
          backpack: "202.182.119.232",
        },

        formInput: {
          exchange: "",
          label: "",
          apiKey: "",
          secret: "",
          password: "",
        },

        formErrorMsg: "",
        isSubmitting: false,
      };
    },

    computed: {
      shouldShowPasswordInput() {
        return ["okx", "kucoin", "bitget"].includes(this.formInput.exchange);
      }
    },

    methods: {
      onClickCopyIp() {
        navigator.clipboard.writeText(this.whitelistIpTextByExchange[this.formInput.exchange] || "");
      },

      beforeSubmit() {
        const trimFields = ["label", "apiKey", "secret"];
        for (const k of trimFields) {
          this.formInput[k] = this.formInput[k].trim();
        }
      },

      async submitForm() {
        try {
          this.isSubmitting = true;
          await cexAccountService.add(this.formInput);
          this.$bvModal.hide(this.modalId);
          this.done();

        } catch (e) {
          console.error(e);
          this.formErrorMsg = e.response?.data?.message || e.message;

        } finally {
          this.isSubmitting = false;
        }
      },

      done() {
        this.$emit("done");
      }
    }
  };
</script>
